/* eslint-disable */
import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
// import checkboxHOC from "./TableHOC";
import checkboxHOC from "react-table/lib/hoc/selectTable";
// import { selectHOC, fetchableHOC } from "./TableHOC";
import _ from "lodash";
import {
  Modal,
  DatetimeRenderers,
  FormButton,
  TopbarList,
  TopbarGridItem,
  TopbarContainer
} from "./Base";
import {
  setClientDateFormat,
  setServerDateFormat,
  setClientDateTimeFormat,
  setYearMonthWeekFormat,
  setClientDateFormatFromYearMonthWeek,
  setEndOfClientDateFormatFromYearMonthWeek,
  dateFormat,
  promiseSerial,
  isString,
  isObject
} from "../utility";
import * as Datetime from "react-datetime";
import FileSaver from "file-saver";
import * as Filters from "./TableFilters";
import { findPaths } from '../lib/helpers';

const SelectTable = checkboxHOC(ReactTable);
// const FetchableSelectTable = fetchableHOC(selectHOC(checkboxHOC(ReactTable)));
// const ConfigurableFetchableTable = configurableHOC(fetchableHOC(ReactTable));

const aggregation = ({ data, column, aggregationtype, datatype }) => {
  let vals = data.map(row => row[column.id]);
  let sum = _.sum(vals);
  // sum = sum ? sum.toFixed(2) : 0.0;
  return sum;
};

const columnFormat = (val, type) => {
  let style = undefined;
  switch (type) {
    case "Text":
      style = {
        textAlign: "left",
        display: "block",
        fontFamily: "adelle-sans, europa, adelle"
      };
      break;
    case "Date":
    case "DateTime":
    case "Time":
      style = {
        textAlign: "left",
        display: "block",
        fontFamily: "adelle-sans, europa, adelle"
      };
      break;
    case "Currency":
    case "Numeric":
    default:
      style = {
        textAlign: "right",
        display: "block",
        fontFamily: "adelle-sans, europa, adelle"
      };
      break;
  }
  return <span style={style}>{val}</span>;
};

const format = (value, type) => {
  let res = undefined;
  switch (type) {
    case "Date":
      res = setClientDateFormat(value);
      break;
    case "DateTime":
      res = setClientDateTimeFormat(value);
      break;
    case "Text":
      res = value;
      break;
    case "Currency":
      res = value && typeof value === 'number' ? value.toFixed(2) + " ₺" : value;
      break;
    case "Numeric":
      res = value;
      break;
    default:
      break;
  }
  return columnFormat(res, type);
};

const columntTypes = ["Date", "DateTime", "Text", "Currency", "Numeric"];

const subComponentConfigurator = (props, subComponent) => {
  let temp = undefined;
  if (!subComponent) return temp;
  switch (subComponent.type) {
    case "React-Table":
      temp = row => {
        let key =
          "key_" +
          row.nestingPath.toString() + //.slice(0, -1)
          "_" +
          row.original[props.config.keyField];
        let config = subComponent[key] ? subComponent[key] : subComponent;
        // console.log("key", key, row, props.config.keyField);
        return (
          <div
            key={key}
            style={{
              paddingLeft: "35px"
            }}
          >
            <ReportTable
              {...props}
              config={{ ...config, parent: row.original }}
              updateconfig={data =>
                props.updateconfig({
                  SubComponent: Object.assign({}, subComponent, {
                    [key]: Object.assign({}, config, data)
                  })
                })
              }
            />
          </div>
        );
      };
      break;
    default:
      temp = row => {
        return <div style={{ padding: "20px" }}>Another Sub Component!</div>;
      };
      break;
  }
  return temp;
};

const columnConfigurator = item => {
  let temp = Object.assign({}, item);
  if (item.Cell) {
    temp.Cell = props => format(props.value, item.Cell);
  }
  if (item.Header) {
    if (isString(item.Header)) {
      temp.Header = columnFormat(item.Header, item.Cell ? item.Cell : "Text");
    }
  }
  if (item.Footer) {
    if (isString(item.Footer)) {
      temp.Footer = ({ data, column }) => {
        let val = format(
          aggregation({
            data,
            column,
            aggregationtype: item.Footer,
            datatype: item.Cell
          }),
          item.Cell
        );
        return val;
      };
    } else if (isObject(item.Footer)) {
      if (item.Footer.type === "Label") {
        temp.Footer = ({ data, column }) => {
          let val = format(item.Footer.value, "Text");
          return val;
        };
      } else {
        temp.Footer = undefined;
      }
    }
  }
  if (item.aggregate) {
    if (isString(item.aggregate)) {
      temp.aggregate = vals => {
        let result = undefined;
        switch (item.aggregate) {
          case "Sum":
            result = _.sum(vals);
            break;
          default:
            result = _.sum(vals);
        }
        return result;
      };
    } else if (isObject(item.aggregate)) {
      if (item.aggregate.type === "Label") {
        temp.aggregate = vals => {
          let val = format(item.aggregate.value, "Text");
          return val;
        };
      } else {
        temp.aggregate = undefined;
      }
    }
  }
  if (item.columns) {
    temp.columns = item.columns.map(columnConfigurator);
  }
  return temp;
};

const configurator = (props, config) => {
  let temp = Object.assign(
    {
      data: [],
      values: [],
      filteredAdd: [],
      pages: null,
      loading: true,
      selection: [],
      selectAll: false,
      firstVisit: true
    },
    config
  );
  return temp;
};

export const FilterPopup = props => {
  if (!props.value) return <span />;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        position: "absolute"
      }}
    >
      {props.value.map((item, index) => (
        <div key={index} style={{ paddingRight: "8px" }}>
          {item.type === "yearmonthweek" &&
            Filters.WeekOfMonth({
              item,
              index,
              value: props.value,
              update: props.update
            })}
          {item.type === "DateInterval" &&
            Filters.DateInterval({
              item,
              index,
              value: props.value,
              update: props.update
            })}
          {item.type === "DateTimeInterval" &&
            Filters.DateTimeInterval({
              item,
              index,
              value: props.value,
              update: props.update
            })}
          {(item.type === "SelectQuery" ||
            item.type === "MultiSelectQuery" ||
            item.type === "SelectList" ||
            item.type === "MultiSelectList") && (
            <Filters.SelectItems {...props} item={item} index={index} />
          )}
        </div>
      ))}
    </div>
  );
};

// function difference(object, base) {
//   function changes(object, base) {
//     return _.transform(object, function(result, value, key) {
//       if (!_.isEqual(value, base[key])) {
//         result[key] =
//           _.isObject(value) && _.isObject(base[key])
//             ? changes(value, base[key])
//             : value;
//       }
//     });
//   }
//   return changes(object, base);
// }

const setDefaultExpanded = (expanded, columns) => {
  let result = undefined;
  switch (expanded) {
    case "All":
      result = Object.assign({}, columns.map(x => true));
      break;
    default:
      result = expanded;
  }
  return result;
};

export class ReportTable extends React.Component {
  constructor(props) {
    super(props);
    // this.state = configurator(props, props.config);
    props.updateconfig(configurator(props, props.config));
    this.downloadData = this.downloadData.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.getWrappedInstance = this.getWrappedInstance.bind(this);
  }
  // shouldComponentUpdate(nextProps) {
  //   // TODO: Component neden güncelleniyor incelenecek....
  //   return !_.isEmpty(difference(nextProps.config, this.props.config));
  // }
  downloadData() {
    let {
      download,
      sorted,
      filtered,
      filteredAdd,
      parent,
      selection
    } = this.getWrappedInstance().getResolvedState();
    let { config } = this.props;

    selection = Array.isArray(selection) ? selection : [undefined];

    let funcs = selection.map(selected => () => {
      this.props.updateconfig({ loading: true });
      return this.props.task_request({
        action: "ReportQueryDownload",
        payload: {
          download,
          sorted,
          filtered,
          filteredAdd,
          parent,
          config,
          selected
        },
        success: result => this.props.updateconfig({ loading: false })
      });
    });

    // console.log("selection: ", selection);
    promiseSerial(funcs);
    // this.setState({ loading: true });
  }
  fetchData(state, instance) {
    // console.log(state.pageSize, instance);
    // if (this.props.config.type === "React-Table") return;

    const cfg = configurator(this.props, this.props.config)
    if (cfg.firstVisit) {
      this.props.updateconfig({ loading: false, firstVisit: false });
      return null;
    };
    this.props.updateconfig({ loading: true });
    // this.setState({ loading: true });

    let description = '';
    this.props.config.filteredAdd.map(item => {
      description += `${item.name}: ${String(item.value)}`
    })
    const fullPath = findPaths(this.props, this.props.match.params.name)
    const report = this.props.Session.RX_Report.first()
    console.log(report)
    this.props.task_request({
      action: "ReportQuerySelect",
      payload: {
        id: state.query, // context filan var onları bir gözden geçirelim...
        pageSize: state.pageSize,
        page: state.page,
        sorted: state.sorted,
        filtered: state.filtered,
        filteredAdd: this.props.config.filteredAdd, //this.props.config.filteredAdd,
        parent: state.parent,
        fullPath,
        description,
        name: state.download.name,
        url: window.location.href,
        datasource: report && report.datasource || 1
      },
      success: result => {
        // let pageSize = state.showPagination ? state.pageSize : result.rowCount;
        // this.setState({
        //   data: result.rows,
        //   pages: Math.ceil(result.rowCount / state.pageSize),
        //   loading: false,
        //   pageSize: pageSize
        // });
        let config = {
          data: result.rows,
          pages: Math.ceil(result.rowCount / state.pageSize),
          loading: false
        };
        if (!state.showPagination) config.pageSize = result.rowCount;
        return this.props.updateconfig(config);
        // return this.props.noop({});
      }
    });
  }
  getWrappedInstance() {
    if (!this.wrappedInstance)
      console.warn("ReSelectTable - No wrapped instance");
    if (this.wrappedInstance.getWrappedInstance)
      return this.wrappedInstance.getWrappedInstance();
    else return this.wrappedInstance;
  }
  toggleSelection(key, shift, row) {
    /*
      Implementation of how to manage the selection state is up to the developer.
      This implementation uses an array stored in the component state.
      Other implementations could use object keys, a Javascript Set, or Redux... etc.
    */
    // start off with the existing state
    let selection = Array.isArray(this.props.config.selection)
      ? [...this.props.config.selection]
      : [];
    const keyIndex = selection.indexOf(key);
    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
    } else {
      // it does not exist so add it
      selection.push(key);
    }
    // update the state
    this.props.updateconfig({ selection });
    // this.setState({ selection });
  }

  toggleAll() {
    /*
      'toggleAll' is a tricky concept with any filterable table
      do you just select ALL the records that are in your data?
      OR
      do you only select ALL the records that are in the current filtered data?
      
      The latter makes more sense because 'selection' is a visual thing for the user.
      This is especially true if you are going to implement a set of external functions
      that act on the selected information (you would not want to DELETE the wrong thing!).
      
      So, to that end, access to the internals of ReactTable are required to get what is
      currently visible in the table (either on the current page or any other page).
      
      The HOC provides a method call 'getWrappedInstance' to get a ref to the wrapped
      ReactTable and then get the internal state and the 'sortedData'. 
      That can then be iterrated to get all the currently visible records and set
      the selection state.
    */
    const selectAll = this.props.config.selectAll ? false : true;
    const selection = [];
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach(item => {
        selection.push(item._original[this.props.config.keyField]);
      });
    }
    // this.setState({ selectAll, selection });
    this.props.updateconfig({ selectAll, selection });
  }

  isSelected(key) {
    /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
    return (
      Array.isArray(this.props.config.selection) &&
      this.props.config.selection.includes(key)
    );
  }
  render() {
    // console.log(
    //   "config: ",
    //   this.props.config,
    //   "expanded: ",
    //   this.props.config.expanded,
    //   "defaultExpanded: ",
    //   this.props.config.defaultExpanded
    // );
    // filteredAdd.map(filter=> filter.value).toString()
    return (
      <div
        style={{
          background: "#FFF",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {this.props.config.filterable && (
          <TopbarContainer
            style={{
              justifyContent: "space-between",
              overflow: "hidden",
              height: "54px"
            }}
          >
            <TopbarList>
              <TopbarGridItem>
                <FilterPopup
                  {...this.props}
                  value={this.props.config.filteredAdd}
                  update={filteredAdd =>
                    this.props.updateconfig({ filteredAdd, expanded: {} })
                  }
                />
              </TopbarGridItem>
            </TopbarList>
            <TopbarList />
            <TopbarList>
              <TopbarGridItem
                onClick={() => this.getWrappedInstance().fireFetchData()}
                title={"Execute"}
              >
                <span style={{ width: "25px" }} className={`fa fa-play`} />
              </TopbarGridItem>
              <TopbarGridItem onClick={this.downloadData} title={"Download"}>
                <span style={{ width: "25px" }} className={`fa fa-download`} />
              </TopbarGridItem>
            </TopbarList>
          </TopbarContainer>
        )}
        {this.props.config.type === "React-Select-Table" && (
          <SelectTable
            {...this.props.config}
            style={{ height: "calc(100% - 54px)" }}
            className="-striped -highlight"
            columns={this.props.config.columns.map(columnConfigurator)}
            SubComponent={subComponentConfigurator(
              this.props,
              this.props.config.SubComponent
            )}
            ExpanderComponent={({ isExpanded, ...rest }) =>
              isExpanded ? (
                <span className={`fa fa-minus-circle`} />
              ) : (
                <span className={`fa fa-plus-circle`} />
              )
            }
            onFetchData={this.fetchData}
            ref={r => (this.wrappedInstance = r)}
            toggleSelection={this.toggleSelection}
            toggleAll={this.toggleAll}
            isSelected={this.isSelected}
            selectAll={this.props.config.selectAll}
            selectType={"checkbox"}
            onExpandedChange={(newExpanded, index, event) => {
              this.props.updateconfig({ expanded: newExpanded });
            }}
            defaultExpanded={setDefaultExpanded(
              this.props.config.defaultExpanded,
              this.props.config.columns
            )}
          />
        )}
        {this.props.config.type === "React-Table" && (
          <ReactTable
            {...this.props.config}
            style={{ height: "calc(100% - 54px)" }}
            className="-striped -highlight"
            columns={this.props.config.columns.map(columnConfigurator)}
            SubComponent={subComponentConfigurator(
              this.props,
              this.props.config.SubComponent
            )}
            ExpanderComponent={({ isExpanded, ...rest }) =>
              isExpanded ? (
                <span className={`fa fa-minus-circle`} />
              ) : (
                <span className={`fa fa-plus-circle`} />
              )
            }
            onFetchData={this.fetchData}
            ref={r => (this.wrappedInstance = r)}
            onExpandedChange={(newExpanded, index, event) => {
              this.props.updateconfig({ expanded: newExpanded });
            }}
            defaultExpanded={setDefaultExpanded(
              this.props.config.defaultExpanded,
              this.props.config.columns
            )}
          />
        )}
        {this.props.config.type === "React-Table_" && (
          <div>{"React-Table_"}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table.js